import React from 'react';
import { Link } from 'react-router-dom';
import ConnectButton from '../Wallet/ConnectButton';
import { useWeb3 } from '../../context/Web3Context';

const Header = ({ onMenuClick }) => {
  const { onCorrectNetwork, account, network, switching, isOwner, isAdmin } = useWeb3();

  return (
    <header className="header">
      <div className="header-inner">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <button className="mobile-menu-btn" onClick={onMenuClick}>≡</button>
          <Link to="/" className="brand">
            <div className="brand-mark"><span>A</span></div>
            <div>
              <div className="brand-name">AMSG</div>
              <div className="brand-tag">Staking Protocol</div>
            </div>
          </Link>
        </div>
        <div className="header-actions">
          {account && isOwner && (
            <span className="badge badge-purple"><span className="badge-dot" />Owner</span>
          )}
          {account && isAdmin && !isOwner && (
            <span className="badge badge-cyan"><span className="badge-dot" />Admin</span>
          )}
          {account && (
            <div className={`network-badge ${!onCorrectNetwork ? 'wrong' : ''}`}>
              <span className="network-dot" />
              {switching ? 'Switching...' : (onCorrectNetwork ? network.displayName : 'Wrong Network')}
            </div>
          )}
          <ConnectButton />
        </div>
      </div>
    </header>
  );
};

export default Header;
